import autobind from 'autobind-decorator';

export class StreamBankContext {
    get parentProgram() {
        return this._parentProgram;
    }
    set parentProgram(value){
        this._parentProgram = value;
    }
    get childProgram() {
        return this._childProgram;
    }
    set childProgram(value){
        this._childProgram = value;
    }
    get project() {
        return this._project;
    }
    set project(value){
        this._project = value;
    }
    get conservationAction() {
        return this._conservationAction;
    }
    set conservationAction(value){
        this._conservationAction = value;
    }

    constructor(parentProgramId = null, childProgramId = null, projectId = null, conActId = null, sampleEventId = null) {
        this.LoadData({
            parentProgram: parentProgramId,
            childProgram: childProgramId,
            project: projectId,
            conservationAction: conActId,
            sampleEvent: sampleEventId
        });
    }

    @autobind
    LoadData(other) {
        this.parentProgram = null;
        this.childProgram = null;
        this.project = null;
        this.conservationAction = null;

        if(other.parentProgram) {
            this.parentProgram = other.parentProgram;
        }
        if(other.childProgram) {
            this.childProgram = other.childProgram;
        }
        if(other.project) {
            this.project = other.project;
        }
        if(other.conservationAction) {
            this.conservationAction = other.conservationAction;
        }
        

        return this;
    }

    @autobind
    Equals(other) {
        return this.parentProgram == other.parentProgram &&
            this.childProgram == other.childProgram &&
            this.project == other.project &&
            this.conservationAction == other.conservationAction;
    }

    @autobind
    Clone() {
        return new StreamBankContext(
            this.parentProgram,
            this.childProgram,
            this.project,
            this.conservationAction
        );
    }

    @autobind
    Merge(other) {
        return new StreamBankContext(
            other.parentProgram || this.parentProgram,
            other.childProgram || this.childProgram,
            other.project || this.project,
            other.conservationAction || this.conservationAction
        );
    }
}
